export function profileButtonInitial(accountProfile = {}, clerkUser = null) {
  const candidates = [
    accountProfile?.display_name,
    clerkUser?.fullName,
    clerkUser?.primaryEmailAddress?.emailAddress,
  ];
  const identity = candidates
    .map(value => typeof value === 'string' ? value.trim() : '')
    .find(Boolean) || 'A';
  return identity[0].toUpperCase();
}
